import React, { useState } from "react";
import PropTypes from "prop-types";

import { Paragraph } from "components/core/Typography";
import { TextButton } from "components/core/Button";
import { Chevron } from "components/core/Icons";

import "./FeeAlert.scss";

const FeeAlert = ({ fees, totalFees, unitPrice }) => {
	const [readMoreShowing, setReadMoreShowing] = useState(false);
	const totalCost = (totalFees + unitPrice).toFixed(2);
	return (
		<div className="admin-fees">
			<Paragraph last weight='semiBold' size='small'>
				The following fees shall apply:
			</Paragraph>
			<ul>
				{fees.map(({ name, price }) => (
					price > 0 &&
						<li key={name}>
							<Paragraph last size='small'>
								{name} - ${price}
							</Paragraph>
						</li>
				))}
			</ul>
			<Paragraph last size='small'>
				{`Your first month's bill will be $${totalCost} plus taxes.`}
			</Paragraph>
			<TextButton
				type="button"
				onClick={() => setReadMoreShowing(!readMoreShowing)}
				className="read-more-toggle"
				color="black"
				fullWidth={false}
				reverse
				icon={
					<Chevron rotate={readMoreShowing ? 'up' : 'down'} color="black"/>
				}
			>
				{readMoreShowing ? 'Close Details' : 'Read More'} About Admin Fees
			</TextButton>
			{ readMoreShowing && 
				<Paragraph last size='small'>
					The one-time, non-refundable admin fee is 
					charged upon signing your lease agreement. 
					This fee covers the costs associated with 
					processing your application and setting up your 
					account and access credentials, ensuring a 
					smooth move-in process.
				</Paragraph>
			}
		</div>
	)
}

FeeAlert.propTypes = {
	fees: PropTypes.arrayOf(PropTypes.object),
	totalFees: PropTypes.number,
	unitPrice: PropTypes.number
};

export default FeeAlert;
